import {Quote} from "../../../api/models";
import {Alert} from "antd";

const AlertStock = ( props: {
  quote:Quote | undefined
}) => {

  if ( !props.quote?.stock ) return <></>

  return <div style={{marginBottom: "1rem"}}>
    <Alert
        type="warning"
        message={<div>This quote is for a stock truck (FGI).</div>}
        closable={true}
    />
  </div>
}

export default AlertStock;
